import { AlertMessage } from 'components/notification/AlertMessage';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useAlertMessage(props) {
    const {         
        generateInvoice_errorMsg,
        generateDebitNote_errorMsg,
        deleteAccount_errorMsg,
    } = props;

    const [alertMsg, setAlertMsg] = useState([]);
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    // Error Messages
    function updateErrorMsg(msg) {
        if (func_validation.isStringTrimNotEmpty(msg)) {
            let alertMsg_new = func_validation.cloneArray(alertMsg);
            let index = func_validation.getArrayLength(alertMsg_new, 0);
    
            alertMsg_new.push(<p key={index}>{msg}</p>);
            setAlertMsg(alertMsg_new);
            setIsAlertMsgVisible(true);
        }
    } 
    useEffect(() => {
        updateErrorMsg(generateInvoice_errorMsg);
    }, [generateInvoice_errorMsg]);
    useEffect(() => {
        updateErrorMsg(generateDebitNote_errorMsg);
    }, [generateDebitNote_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deleteAccount_errorMsg);
    }, [deleteAccount_errorMsg]);
    
    let alertMsgDisplay = (
        <AlertMessage
            message={alertMsg}
            isVisible={isAlertMsgVisible}
            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
        />
    );

    return {
        alertMsgDisplay,
        setAlertMsg
    };
}